import { Link } from 'react-router-dom';
import { categories } from '@/mocks/data';
import AnimateIn from '@/components/base/AnimateIn';

export default function CategoryCards() {
  return (
    <section className="w-full px-4 md:px-6 py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            探索内容分类
          </h2>
          <p className="mt-3 text-foreground-500 text-sm md:text-base max-w-xl mx-auto">
            六大内容板块，满足你的不同需求，轻松找到感兴趣的内容
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {categories.map((cat, idx) => (
            <AnimateIn key={cat.slug} delay={idx * 80}>
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group bg-background-50 rounded-xl p-6 transition-all duration-300 hover:bg-background-50 hover:scale-[1.02]"
            >
              <div className="w-12 h-12 rounded-lg bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${cat.icon} text-xl text-primary-600`}></i>
              </div>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-2">
                {cat.name}
              </h3>
              <p className="text-sm text-foreground-500 leading-relaxed">
                {cat.description}
              </p>
              <div className="mt-4 flex items-center gap-1 text-sm text-primary-500 font-medium">
                <span>浏览更多</span>
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
            </AnimateIn>
          ))}
        </div>
      </div>
    </section>
  );
}